import API from 'api';
import * as C from './constants';
import receiveNetworkException from './network';
import error from './error';

export const loadSuccess = (res) => ({
  type: C.LOAD_INSIGHTS_SUCCESS,
  data: res,
});

export const load = (props) => (dispatch) => {
  dispatch({ type: C.LOAD_INSIGHTS });
  return API.insights.load(props)
    .then(({ body }) => {
      const { data, included, meta } = body;

      // Sort insights by created_at in descending order
      const sortedData = data.sort((a, b) => {
        const dateA = new Date(a.attributes.created_at);
        const dateB = new Date(b.attributes.created_at);
        return dateB - dateA;
      });

      return dispatch(loadSuccess({
        list: sortedData,
        meta,
      }));
    })
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_INSIGHTS_ERROR, 'Error loading insights'));
    });
};

export const create = (reportId, data) => (dispatch) => {
  dispatch({ type: C.CREATE_INSIGHT });
  return API.insights.create(reportId, data)
    .then(({ body }) => {
      dispatch({ type: C.CREATE_INSIGHT_SUCCESS });
      return body;
    })
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.CREATE_INSIGHT_ERROR, 'Error creating insight'));
    });
};

export const deleteInsight = (insightId) => (dispatch) => {
  dispatch({ type: C.DELETE_INSIGHT });
  return API.insights.deleteInsight(insightId)
    .then(() => {
      dispatch({ type: C.DELETE_INSIGHT_SUCCESS });
      return true;
    })
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.DELETE_INSIGHT_ERROR, 'Error deleting insight'));
    });
}; 